import { render } from "./SectionsDetailTableUnitedMeasures.vue?vue&type=template&id=6822c40e"
import script from "./SectionsDetailTableUnitedMeasures.vue?vue&type=script&lang=js"
export * from "./SectionsDetailTableUnitedMeasures.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__